import React from 'react';

import { TableCell, Theme } from '@mui/material';
import { SxProps } from '@mui/system';

import TableGroupRow from '../../../../components/TableGroupRow';
import { IStaffTravel } from '../../../../types/staff-travel.type';
import { ArrayUtils } from '../../../../utils/array.utils';

interface IProps {
  groupName: string;
  travel: IStaffTravel[];
}

const sxNumberCell: SxProps<Theme> = { fontWeight: 'bold', textAlign: 'center' };

const StaffTravelListGroup = React.memo(({ groupName, travel }: IProps) => (
  <TableGroupRow groupTitle={groupName} groupRowColSpan={4}>
    <TableCell sx={sxNumberCell}>{ArrayUtils.calculateTotal(travel, 'total')}</TableCell>
  </TableGroupRow>
));

export default StaffTravelListGroup;
